import React from "react";
import { Link } from "react-router-dom";
import Clock from "react-live-clock";
import StepProgress from "./StepProgress";
import "./style/doctorVideoStatics.css";
import { useHistory } from "react-router";

function DoctorVideoStatics(props) {
  const history = useHistory();

  return (
    <div className="container-fluid pl-0 pr-0 doctor-contanier overflow-hidden">
      <header>
        <div className="container-fluid">
          <div className="row ai-center">
            <div className="col-6 col-md-3">
              <a href="" className="logo">
                <img
                  src={process.env.PUBLIC_URL + "/images/HN_logo.png"}
                  style={{ width: "70%" }}
                  onClick={() => {
                    history.push({
                      pathname: "/doctor/account/dashboard",
                    });
                  }}
                />
              </a>
            </div>
            <div className="col-6 col-md-9">
              {/* <div className="desk-video-duration video-duration df ai-center">
                                <p className="mr-5">
                                    <span>
                                        <Clock format={"HH:mm:ss"} ticking={true} />
                                    </span>
                                </p>
                                <p>
                                    <span>Patient:</span> kundan
                                </p>
                            </div> */}
              {/* <Link className="login-btn" href="" to="/doctor/account">
                                Dashboard
                            </Link> */}
            </div>
          </div>
        </div>
      </header>
      <section className="pro-body-content">
        <div className="pro-doctor-video">
          <div>
            <div className="video-col-left p-0">
              <StepProgress props={props} />
              {/* <div className="iframe_container for_desktop">
                                <div className="each_iframe_cont">
                                    <iframe src="https://www.connect2clinic.com/" title="connect2clinic " />
                                </div>
                            </div> */}
            </div>

            <div className="video-col-right patient_video">
              <div className="video_content">
                {/* <div className="video_content_overlay"></div>
                                <p className="wating_text">Waiting for patient to join after the payment is done</p> */}
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/consultation_screen.png"
                  }
                />
              </div>
            </div>

            {/* <div className="iframe_container for_mobile">
                            <div className="each_iframe_cont">
                                <iframe src="https://www.connect2clinic.com/" title="connect2clinic " />
                            </div>
                        </div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default DoctorVideoStatics;
